import { useState } from "react";
import { Form, Link, useRouteLoaderData } from "react-router-dom";
import Cleave from "cleave.js/react";

import { states, cityStates } from "src/components/common/cityState";
import { Vendor } from "./types";

export default function VendorForm({
    keyword,
}: {
    keyword: "Add" | "Edit";
}) {
    const loaderVendor = (useRouteLoaderData("vendor") as { vendor?: Vendor } | undefined)?.vendor ?? {
        id: "",
        vendorName: "",
        website: "",
        phoneNumber: "",
        extension: "",
        fax: "",
        country: "",
        state: "",
        city: "",
        street: "",
        zipCode: "",
        background: "",
    };
    const [formValues, setFormValues] = useState(loaderVendor);
    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
    ) => {
        const { name, value } = e.target;
        setFormValues(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    return (
        <Form method = "post">
            <input type = "hidden" name = "action" value = {keyword} />
            <input type = "hidden" name = "id" value = {formValues.id ?? ""} />
            <div className = "cssSeperateWhenWide ps-3 mb-2">
                <div className = "flex-grow-1 me-3">
                    <div className = "d-flex align-items-center mt-2">
                        <label className = "fw-bold text-nowrap mb-0" htmlFor = "vendorName">Vendor Name:</label>
                        <input
                            className = "form-control flex-grow-1 ms-3"
                            required
                            id = "vendorName"
                            name = "vendorName"
                            value = {formValues.vendorName ?? ""}
                            onChange = {handleChange}
                        />
                    </div>
                    <div className = "d-flex align-items-center mt-2">
                        <label className = "fw-bold mb-0" htmlFor = "website">Website:</label>
                        <input
                            type = "url"
                            className = "form-control flex-grow-1 ms-3"
                            id = "website"
                            name = "website"
                            value = {formValues.website ?? ""}
                            onChange = {handleChange}
                        />
                    </div>
                    <div className = "d-flex align-items-center mt-2">
                        <label className = "fw-bold text-nowrap mb-0" htmlFor = "phoneNumber">Business Phone:</label>
                        <Cleave
                            className = "form-control flex-grow-1 ms-3"
                            id = "phoneNumber"
                            name = "phoneNumber"
                            value = {formValues.phoneNumber ?? ""}
                            onChange = {e => setFormValues({ ...formValues, phoneNumber: e.target.value })}
                            options = {{
                                blocks: [3, 3, 4],
                                delimiter: "-",
                                numericOnly: true,
                            }}
                        />
                    </div>
                    <div className = "d-flex align-items-center mt-2">
                        <label className = "fw-bold mb-0" htmlFor = "extension">Extension:</label>
                        <input
                            className = "form-control flex-grow-1 ms-3"
                            id = "extension"
                            name = "extension"
                            value = {formValues.extension ?? ""}
                            onChange = {handleChange}
                        />
                    </div>
                    <div className = "d-flex align-items-center mt-2">
                        <label className = "fw-bold mb-0" htmlFor = "fax">Fax:</label>
                        <Cleave
                            className = "form-control flex-grow-1 ms-3"
                            id = "fax"
                            name = "fax"
                            value = {formValues.fax ?? ""}
                            onChange = {e => setFormValues({ ...formValues, fax: e.target.value })}
                            options = {{
                                blocks: [3, 3, 4],
                                delimiter: "-",
                                numericOnly: true,
                            }}
                        />
                    </div>
                </div>
                <div className = "flex-grow-1 me-3">
                    <h4 className = "fw-bold text-center mt-2">Address</h4>
                    <div className = "d-flex align-items-center mt-2">
                        <label className = "fw-bold mb-0" htmlFor = "street">Street:</label>
                        <input
                            className = "form-control flex-grow-1 ms-3"
                            id = "street"
                            name = "street"
                            value = {formValues.street ?? ""}
                            onChange = {handleChange}
                        />
                    </div>
                    <div className = "d-flex align-items-center mt-2">
                        <label className = "fw-bold" htmlFor = "city">City:</label>
                        <select
                            className = "form-control flex-grow-1 ms-3"
                            id = "city"
                            name = "city"
                            value = {formValues.city ?? ""}
                            onChange = {handleChange}
                        >
                            <option value = "">Select</option>
                            {formValues.state && cityStates[formValues.state as keyof typeof cityStates]?.map((city, i) => <option key = {i}>{city}</option>)}
                        </select>
                    </div>
                    <div className = "d-flex align-items-center mt-2">
                        <label className = "fw-bold" htmlFor = "state">State:</label>
                        <select
                            className = "form-control flex-grow-1 ms-3"
                            id = "state"
                            name = "state"
                            value = {formValues.state ?? ""}
                            onChange = {handleChange}
                        >
                            <option value = "">Select</option>
                            {states.map((state, i) => <option key = {i}>{state}</option>)}
                        </select>
                    </div>
                    <div className = "d-flex align-items-center mt-2">
                        <label className = "fw-bold text-nowrap" htmlFor = "zipCode">Zip Code:</label>
                        <input
                            className = "form-control flex-grow-1 ms-3"
                            id = "zipCode"
                            name = "zipCode"
                            value = {formValues.zipCode ?? ""}
                            onChange = {handleChange}
                        />
                    </div>
                    <div className = "d-flex align-items-center mt-2">
                        <label className = "fw-bold text-nowrap" htmlFor = "country">Country:</label>
                        <input
                            className = "form-control flex-grow-1 ms-3"
                            id = "country"
                            name = "country"
                            value = {formValues.country ?? ""}
                            onChange = {handleChange}
                        />
                    </div>
                </div>
                <div className = "d-flex flex-column align-items-start mt-2">
                    <label className = "fw-bold mb-0" htmlFor = "background">Background:</label>
                    <textarea
                        className = "form-control w-100 flex-grow-1"
                        id = "background"
                        name = "background"
                        value = {formValues.background ?? ""}
                        onChange = {handleChange}
                    />
                </div>
            </div>
            <div className = "my-3">
                <button type = "submit" className = "btn btn-primary">{keyword}</button>
                <Link to = ".." className = "btn btn-outline-secondary float-end">Back</Link>
            </div>
        </Form>
    );
}
